import {Image, Space, Layout, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';
const {Text, Paragraph} = Typography;
const Content = Layout;

const TestTrialsTab = () => {
  return (
    <Layout style={{borderStyle: 'solid', borderWidth: '2vh', margin: '-2vh -2vh -2vh -2vh', background: appColors['ColorG2'], borderTopColor: appColors['ColorX'], borderBottomColor: appColors['ColorX'], borderRightColor: appColors['ColorX'], borderLeftColor: appColors['ColorX']}}>
      <Layout style={{background: 'transparent', margin: '5.2vh 5.2vh 5.2vh 5.2vh'}}>
        <Paragraph className='Title4' style={{color: appColors['ColorX'], marginTop: '3vh', fontSize: '3.5vh', textAlign: 'center'}}><b>Here we find that doctors and researchers are interested in giving feedback to improve the diagnosis technique to establish a simpler way to interpret the results.<br/>We&apos;ll have more laboratory validations.</b></Paragraph>
        <Space size={80} align="center" style={{background: 'inherit', width: 'fit-content', marginTop: '2%'}}>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%'}}>
            <Text className='BaseText5'><b>The National Institute of Geriatrics (INGER)</b> focuses on topics concerning ageing. Our mission is common because they promote healthy aging through the production of new knowledge. They <b>also support the implementation of our point of care in private and public sectors.</b> All this to improve the quality of life of the elders. (Check Human Practices Section) <br/>http://www.geriatria.salud.gob.mx/</Text>
          </Content>
          <Content style={{width: 'fit-content', display: 'block', marginTop: '3%', background: 'transparent'}}>
            <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-7.png'/>
          </Content>
        </Space>
        <Space size={80} align="center" style={{background: 'inherit', width: 'fit-content', marginTop: '5%'}}>
          <Content style={{width: 'fit-content', display: 'block', marginTop: '3%', background: 'transparent'}}>
            <Image src='https://static.igem.wiki/teams/4464/wiki/emprendimiento/imagen-8.jpg'/>
          </Content>
          <Content style={{float: 'left', background: 'inherit', marginTop: '6%'}}>
            <Text className='BaseText5'><b>BIOLAN HEALTH</b> offers personalized services, universities  and research centers to <b>analyze parameters of interest in a fast, economical and reliable way.</b> Their scientific team has extensive experience in the development of R&D activities related to the application of immunoassays.<br/>https://biolanhealth.com/ </Text>
          </Content>
        </Space>
      </Layout>
    </Layout>
  );
};

export default TestTrialsTab;
